<script setup lang="ts">
const props = defineProps<{
  type?: string;
  color?: string;
  active?: boolean;
  to?: string;
  icon?: string;
  href?: string;
  id?: string;
  gaLoop?: boolean;
  placeholder?: boolean;
}>();

const slots = useSlots();
const empty = computed(() => !slots.default);
const color = computed(() => props.color || undefined);
</script>

<template>
  <span
    v-if="placeholder"
    class="nav-product-link"
    :class="{ active: active }"
  >
    <span
      class="placeholder"
      :style="{ color: color, width: '1em' }"
    />
    <span class="text">
      <span
        class="placeholder"
        style="width: 50px"
      />
    </span>
  </span>
  <router-link
    v-else-if="!empty && to"
    :id="id"
    :class="{ active: props.active, 'ga-loop': gaLoop }"
    :to="to"
    class="nav-product-link"
    :data-loopcommunity-link="gaLoop ? 'SongDetail' : undefined"
  >
    <i
      v-if="icon"
      class="link-icon"
      :class="icon"
      :style="{ color: color }"
    />
    <span class="text">
      <slot></slot>
    </span>
  </router-link>
  <a
    v-else-if="!empty && href"
    :id="id"
    :class="{ active: active, 'ga-loop': gaLoop }"
    :href="href"
    class="nav-product-link"
    target="_blank"
    :data-loopcommunity-link="gaLoop ? 'SongDetail' : undefined"
  >
    <i
      v-if="icon"
      class="link-icon"
      :class="icon"
      :style="{ color: color }"
    />
    <span class="text">
      <slot></slot>
    </span>
  </a>
</template>

<style scoped lang="postcss">
span,
a,
button {
  &.nav-product-link {
    @apply flex h-12 items-center justify-center gap-1 rounded-full px-4 text-lg leading-4 sm:h-16 sm:px-10;
  }
}

a,
button {
  @apply flex h-12 items-center justify-center gap-1 rounded-full px-6 text-lg leading-4 transition-all sm:h-16 sm:px-10;

  &:not(.router-link-exact-active) {
    @apply px-2 sm:px-6 2xl:px-10;
    .text {
      @apply hidden xl:inline;
    }
    &:hover {
      @apply bg-light-500;
    }
  }

  &.router-link-exact-active {
    @apply pointer-events-none bg-primary font-bold text-white;
    i,
    svg {
      @apply text-white;
    }
    .text {
      @apply hidden sm:inline;
    }
  }
}

.link-icon {
  @apply text-xl text-primary sm:text-2xl;
}
.ga-loop .link-icon {
  @apply text-loop-green;
}
</style>
